import React from 'react';
import { ManifestType, ThemeType, ProjectType, PageType, OrganizationType } from '@/types/publishedAssets';
import { SurveyType } from '@/types/survey';
import { UrlParams } from '@/types/urlParams';
import { FeedItem } from 'types/feeds';
import { QbSurveyInfo } from 'types/qbSurveyInfo';
import type { PageHostnames } from '@/customDomains/types';

export enum Actions {
  USER_INTERACTION = 'userInteraction',
  SET_THEME = 'setTheme', // used for loading theme via client in case of 404
  MARK_SURVEY_COMPLETE = 'markSurveyComplete', // used to enable reset button on footer
  SET_SURVEY = 'setSurvey', // used for if version mis matched
  SET_SUBMISSION_UUID = 'setSubmissionUuid', // current survey submission, sent with notification sign-up
}

export interface ActionType {
  type: Actions;
  payload?: unknown;
}

export interface PageContextInterface extends PageHostnames {
  survey?: SurveyType;
  page?: PageType;
  questionnaire?: QbSurveyInfo;
  theme?: ThemeType;
  manifest?: ManifestType;
  urlParams?: UrlParams;
  slug: string[];
  project?: ProjectType;
  userInteraction?: number;
  surveyComplete?: boolean;
  auth0Token?: string;
  preview?: boolean;
  forceLanguageMenu?: boolean;
  dispatch?: React.Dispatch<ActionType>;
  feeds?: Record<string, FeedItem[]>; // Map of content ID to feed data for SEO
  organization?: OrganizationType;
  submissionUuid?: string;
}

export const PageContext = React.createContext<PageContextInterface>({} as PageContextInterface);

export const PageReducer = (state: PageContextInterface, action: ActionType) => {
  switch (action.type) {
    case Actions.USER_INTERACTION:
      return { ...state, userInteraction: (state?.userInteraction || 0) + 1 };
    case Actions.SET_THEME:
      return { ...state, theme: action.payload as ThemeType };
    case Actions.MARK_SURVEY_COMPLETE:
      return { ...state, surveyComplete: true };
    case Actions.SET_SURVEY:
      return { ...state, survey: action.payload as SurveyType };
    case Actions.SET_SUBMISSION_UUID:
      return { ...state, submissionUuid: action.payload as string };
    default:
      return state;
  }
};
